import LoyaltyMessages from './localization'

export default {
  localization: LoyaltyMessages,
}
